import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import { isH5 } from '@/utils/publicRules'
Vue.use(VueRouter)

const routes = [

  {
    path: '/',
    name: 'home',
    component: () => import('../views/home/index.vue'),
    meta: { title: '', name: '首页' }
  },
  {
    path: '/resourceDetail',
    name: 'resourceDetail',
    component: () => import('../views/resourceDetail/index.vue'),
    props: true,
    meta: { title: '', name: '资源详情' }
  },
  {
    path: '/resourceList',
    name: 'resourceList',
    component: () => import('../views/resourceList/index.vue'),
    meta: { title: '', name: '资源列表' }
  },
  {
    path: '/teachHall',
    name: 'teachHall',
    component: () => import('../views/teachHall/index.vue'),
    meta: { title: '', name: '名师讲堂' },

  },
  {
    path: '/teachHallDetail',
    name: 'teachHallDetail',
    component: () => import('../views/teachHall/teachHallDetail/index.vue'),
    meta: { title: '', name: '名师讲堂' },

  },
  {
    path: '/newsInfo',
    name: 'newsInfo',
    component: () => import('../views/newsInfo/index.vue'),
    meta: { title: '', name: '职教资讯', keepAlive: true },

  }
  ,
  {
    path: '/policyList',
    name: 'policyList',
    component: () => import('../views/policyList/index.vue'),
    meta: { title: '', name: '政策法规' },

  }
  ,
  {
    path: '/noticeList',
    name: 'noticeList',
    component: () => import('../views/noticeList/index.vue'),
    meta: { title: '', name: '通知公告' },

  },
  {
    path: '/noticeDetail',
    name: 'noticeDetail',
    component: () => import('../views/noticeDetail/index.vue'),
    meta: { title: '', name: '公告详情' },

  }, {
    path: '/aboutDetail',
    name: 'aboutDetail',
    component: () => import('../views/aboutDetail/index.vue'),
    meta: { title: '', name: '关于我们' },

  },
  {
    path: '/helpCenter',
    name: 'helpCenter',
    component: () => import('../views/helpCenter/index.vue'),
    meta: { title: '', name: '帮助中心' },

  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/personCenter/login/register.vue'),
    meta: { title: '', name: '注册' },

  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/personCenter/login/login.vue'),
    meta: { title: '', name: '用户登录' },

  },
  {
    path: '/personCenter',
    name: 'personCenter',
    component: () => import('../views/personCenter/index.vue'),
    meta: { title: '', name: '个人中心' },

  },
  {
    path: '/forgetPass',
    name: 'forgetPass',
    component: () => import('../views/personCenter/forgetPass.vue'),
    meta: { title: '', name: '忘记密码' },

  },
  {
    path: '/schoolList',
    name: 'schoolList',
    component: () => import('../views/schoolList/index.vue'),
    meta: { title: '', name: '院校列表' },

  },
  {
    path: '/resourceSearch',
    name: 'resourceSearch',
    component: () => import('../views/resourceSearch/index.vue'),
    meta: { title: '', name: '资源中心' },

  },
  {
    path: '/h5',
    name: 'h5',
    component: () => import('../views/h5/index.vue'),
    meta: { title: '', name: '首页' },

  },
  {
    path: '/protocal',
    name: 'protocal',
    component: () => import('../views/protocal/index.vue'),
    meta: { title: '', name: '用户协议' },

  }

]

const router = new VueRouter({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes
});

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

router.beforeEach((to, from, next) => {
  const nav_index = localStorage.getItem('a_index')
  if (to.path == '/') {
    if (isH5()) {
      router.push('/h5')
    }
    store.commit('set_nav_index', 0)
  } else if (to.path == '/resourceList' || to.path == '/resourceDetail' || to.path == '/resourceSearch') {
    store.commit('set_nav_index', 4)
  } else if (to.path == '/schoolList') {
    store.commit('set_nav_index', 5)
  } else if (to.path == '/schoolList' || to.path == '/register' || to.path == '/login'|| to.path == '/teachHall') {
    store.commit('set_nav_index', -1)
  } else {
    store.commit('set_nav_index', nav_index)
  }
  // document.title = to.meta.title
  next()
})

export default router
